import AllenDNLogoWhite from "@/components/SVG/AllenDNLogoWhite";
import FaClose from "@/components/SVG/Fontawesome/FaClose";
import { resetOffCanvasView, selectCameraHelp, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const dispatch = useDispatch();
  const help = useSelector(selectCameraHelp);

  const closeCamera = () => {
    if (help) {
      dispatch(updateOffCanvasViewPayload({ CAMERA: { help: false } }));
      return;
    }
    dispatch(resetOffCanvasView());
  }

  return <div className="w-full shrink-0 grid grid-cols-6 justify-items-center place-items-center z-10 bg-black h-20 text-white text-2xl">
    {/* <button><FaHistory className="w-7 h-7 fill-white" /></button> */}
    <span></span>
    <span></span>
    <span className="col-span-2"><AllenDNLogoWhite className=" w-full h-full" /></span>
    <span></span>
    <button onClick={closeCamera}>
      <FaClose />
    </button>
  </div>
}

export default Header;